import type { FC } from 'react'
import type { ImageProps } from 'next/image'
import clsx from 'clsx'
import { UniversalImage } from '@components/common/UniversalImage'
import { hasCloudinaryImages, getFirstCloudinaryImage } from '@utils/product/cloudinary-images-utils'
import type { Product } from '@model/product'
import { Transformations, TRANSFORMATIONS } from '@components/common/UniversalImage/UniversalImage'

const DEFAULT_HEIGHT = 128
const DEFAULT_WIDTH = 324

interface ProductImageProps extends ImageProps {
  product?: Product
  transformations: Transformations
}

const ProductImage: FC<ProductImageProps> = (props) => {
  const { src, alt, className, product, transformations = 'big', ...restImageProps } = props
  const heightOrDefault = restImageProps.height || DEFAULT_HEIGHT
  const widthOrDefault = restImageProps.width || DEFAULT_WIDTH

  const hasCloudinary = product && hasCloudinaryImages(product)
  const cloudinaryImage = hasCloudinary ? getFirstCloudinaryImage(product) : null
  return (
    <UniversalImage
      {...(hasCloudinary
        ? {
            provider: 'cloudinary' as const,
            src: cloudinaryImage!,
            namedTransformations: TRANSFORMATIONS[transformations],
          }
        : { provider: 'next' as const, src: src })}
      alt={alt}
      height={heightOrDefault}
      width={widthOrDefault}
      quality={80}
      style={{ objectFit: 'contain' }}
      className={clsx('flex justify-center', className)}
    />
  )
}

export default ProductImage
